<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Regisztráció') }}</h1>

        <form class="md:gap-8 md:grid md:grid-cols-2"
              v-on:keyup.enter="submit"
        >
            <div class="flex flex-col md:items-center">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Belépési adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="email" required type="email"
                                v-bind:invalid="!!requestStore.errors?.email || (email.length > 0 && !validEmail)"
                                v-bind:label="__('E-mail cím')"
                                v-bind:placeholder="__('placeholders.email')"
                                v-model="email"
                                v-on:keyup="validateEmail"
                />
                <span class="px-1 text-error text-xs" v-if="email.length > 0 && !validEmail">
                    {{ __('Az email cím formátuma nem megfelelő.') }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password" placeholder="**********" required type="password"
                                v-bind:invalid="!!requestStore.errors?.password || (password.length > 0 && password.length < 8)"
                                v-bind:label="__('Jelszó')"
                                v-model="password"
                />
                <span class="px-1 text-error text-xs" v-if="password.length > 0 && password.length < 8">
                    {{ __('A jelszó legalább :length karakterből kell álljon.', { 'length' : 8 }) }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password_confirmation" placeholder="**********" required type="password"
                                v-bind:invalid="!!requestStore.errors?.password_confirmation || (password.length > 0 && password !== passwordConfirmation)"
                                v-bind:label="__('Jelszó újra')"
                                v-model="passwordConfirmation"
                />
                <span class="px-1 text-error text-xs" v-if="password.length > 0 && password !== passwordConfirmation">
                    {{ __('A jelszavak nem egyeznek.') }}
                </span>
            </div>

            <div class="flex flex-col md:items-center md:mt-0 mt-8">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Személyes adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="lastname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.lastname"
                                v-bind:label="__('Vezetéknév')"
                                v-bind:placeholder="__('placeholders.lastname')"
                                v-model="lastname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="firstname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.firstname"
                                v-bind:label="__('Keresztnév')"
                                v-bind:placeholder="__('placeholders.firstname')"
                                v-model="firstname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="phone" required type="text"
                                v-bind:invalid="!!requestStore.errors?.phone"
                                v-bind:label="__('Telefonszám')"
                                v-bind:placeholder="__('placeholders.phone')"
                                v-model="phone"
                />
            </div>
        </form>

        <div class="flex items-center justify-center my-8 text-sm">
            <c-control-toggle class="h-[30px] mr-4" name="accepted" v-model="accepted"
            />
            <span v-html="__('acceptTerms')" />
        </div>

        <div class="flex flex-col items-center mx-auto">
            <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 normal-case px-4 py-2 rounded-none text-center !text-lg text-white transition-colors w-48"
                      v-bind:disabled="firstname.length === 0 || lastname.length === 0 || phone.length === 0 || !validEmail || password.length < 8 || password !== passwordConfirmation || !accepted"
                      v-on:click="submit"
            >
                {{ __('Regisztráció') }}
            </c-button>

            <span class="flex text-sm">
                {{ __('Van már fiókod?') }}
                <router-link class="block underline ml-1 text-highlight"
                             v-bind:to="{ name : 'login' }">
                    {{ __('Jelentkezz be') }}
                </router-link>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import {
        CButton,
        CControlText,
        CControlToggle,
    } from '@teamfurther/cinderblock';
    import { useRequestStore }  from '../../stores/request';
    import { useSessionStore }  from '../../stores/session';

    const accepted = ref<boolean>(false);
    const email = ref('');
    const firstname = ref<string>('');
    const lastname = ref<string>('');
    const password = ref('');
    const passwordConfirmation = ref('');
    const phone = ref('');
    const requestStore = useRequestStore();
    const sessionStore = useSessionStore();
    const validEmail = ref<boolean>(false);

    async function submit() {
        await sessionStore.registerUser(
            accepted.value,
            email.value,
            firstname.value,
            lastname.value,
            password.value,
            phone.value,
        );
    }

    function validateEmail() {
        validEmail.value = !!email.value.match(/\S+@\S+\.\S+/);
    }
</script>
